export interface CandidateWorkHistory {
  id: string;
  title: string;
  company: string;
  location: string;
  startDate: string | null;
  endDate: string | null;
  isCurrent: boolean;
  description: string;
  achievements: string;
  createdAt: string;
  updatedAt: string;
}

export interface CandidateEducation {
  id: string;
  institution: string;
  degree: string;
  fieldOfStudy: string;
  startYear: number | null;
  endYear: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface CandidateProfile {
  id: string; // UUID → string
  userId: string;

  firstName: string;
  lastName: string;
  city: string;
  systemRole: string;

  // Advanced Info
  professionalHeadline: string;
  profilePhotoUrl: string;
  currentRole: string;
  currentCompany: string;
  totalYearsOfExperience: number | null;

  roleLevel: string;
  targetRole: string[];
  ownerShipLevel: string[];
  teamSizeLed: string;
  hiringAuthority: string[];

  productScale: string[];
  technologyStack:string[]
  architectureExperience: string[];

  businessImpactType: string[];
  businessImpactDescription: string[];
  complexProblemSolved: string[];
  topAchievements: string[];

  domainExpertise: string[];
  coreExpertise: string[];
  reputationSignals: string[];
  workStyle: string[];

  careerIntent: string[];

  availabilityStatus: string;
  workFlexibility: string;
  decisionSpeed: string;

  notableCompanies: string[];

  professionalPitch: string;
  interviewReadiness: string;
  startupRiskPreference: string[];

  leadershipScore: string;
  architectureScore: string;
  businessImpactScore: string;
  achievementScore:string;
  overallScore: string;

  // Compensation
  currentCompensation: number | null;
  expectedCompensation: number | null;
  minimumAcceptableCompensation: number | null;
  noticePeriodDays: number | null;

  // Leadership & Executive Scope
  yearsInLeadership: number | null;
  reportsToLevel: string;
  budgetManagedLakhs: number | null;
  revenueScopeCrores: number | null;
  boardOrInvestorExposure: boolean;
  travelWillingnessPercent: number | null;
  highestEducation: string;

  functionScope: string[];
  geographicScope: string[];
  companyStageExperience: string[];
  transformationExperience: string[];
  executiveEducation: string[];
  languages: string[];

  workHistory: CandidateWorkHistory[];
  education: CandidateEducation[];

  // Trust & Profile
  linkedInUrl: string;
  workEmail: string;
  phoneNumber: string;

  linkedinVerified: boolean;
  workEmailVerified: boolean;
  phoneVerified: boolean;
  profileVerified: boolean;

  // System Fields
  profileComplete: boolean;
  createdAt: string; // ISO string
  updatedAt: string;

  canViewContactDetails: boolean;


  //user details
     userEmail: string;
     userRole: string;
     isUserVerified: boolean;
     userStatus: string;
     profileCompleteScore:string

}


export const initialCandidateProfile: CandidateProfile = {
  id: "",
  userId: "",

  firstName: "",
  lastName: "",
  city: "",
  systemRole: "",

  professionalHeadline: "",
  profilePhotoUrl: "",
  currentRole: "",
  currentCompany: "",
  totalYearsOfExperience: null,

  roleLevel: "",
  targetRole: [],
  ownerShipLevel: [],
  teamSizeLed: "",
  hiringAuthority: [],

  productScale: [],
  technologyStack:[],
  architectureExperience: [],

  businessImpactType: [],
  businessImpactDescription: [],
  complexProblemSolved: [],
  topAchievements: [],

  domainExpertise: [],
  coreExpertise: [],
  reputationSignals: [],
  workStyle: [],

  careerIntent: [],

  availabilityStatus: "",
  workFlexibility: "",
  decisionSpeed: "",

  notableCompanies: [],

  professionalPitch: "",
  interviewReadiness: "",
  startupRiskPreference: [],

  leadershipScore: "",
  architectureScore: "",
  businessImpactScore: "",
  achievementScore:"",
  overallScore: "",

  currentCompensation: null,
  expectedCompensation: null,
  minimumAcceptableCompensation: null,
  noticePeriodDays: null,

  yearsInLeadership: null,
  reportsToLevel: "",
  budgetManagedLakhs: null,
  revenueScopeCrores: null,
  boardOrInvestorExposure: false,
  travelWillingnessPercent: null,
  highestEducation: "",

  functionScope: [],
  geographicScope: [],
  companyStageExperience: [],
  transformationExperience: [],
  executiveEducation: [],
  languages: [],

  workHistory: [],
  education: [],

  linkedInUrl: "",
  workEmail: "",
  phoneNumber: "",

  linkedinVerified: false,
  workEmailVerified: false,
  phoneVerified: false,
  profileVerified: false,

  profileComplete: false,
  createdAt: "",
  updatedAt: "",

  userEmail: "",
  userRole: "",
  isUserVerified: false,
  userStatus: "",
  profileCompleteScore:"",
  canViewContactDetails:false,

};




export interface CandidateInvitationStats {
  receivedInvitationCount: number;
  acceptedInvitationCount: number;
  rejectedInvitationCount: number;
}


// Request DTO
export interface AllInvitationByInvitedUserRequestDTO {
  userId: string;
}

// Response DTO
export interface AllInvitationByInvitedUserResponseDTO {
  invitationId: string;
  email: string;
  firstName: string;
  lastName: string;
  userRole: string | null;

  invitationStatus: string;
  inviteCode: string;

  inviteCountRemaining: number;

  used: boolean;
  revoked?: boolean;
  revokedAt?: string | null;
  userStatus: string;
  createdAt: string;
  inviteUrl: string;
  expiryAt: string;

  inviteId: string;
  userId: string | null;
  userCreatedAt: string | null;
  registrationStatus: 'REGISTERED' | 'NOT_REGISTERED' | string;
}

/**
 * Aggregate counts for a user's invite-link listing.
 */
export interface InvitationStats {
 total: number;
 active: number;
 used: number;
 expired: number;
 revoked: number;
 registered: number;
  /** Credits left to share. */
  inviteBalance: number;
  /**
   * Credits ever granted. Rises with admin top-ups, so it is the real ceiling rather than the
   * configured default.
   */
  inviteTotal: number;
 }



export interface CandidateTotalCountResponse {
  allCandidates: number;
  activeCandidates: number;
  activelyExploringCandidates: number;
  newlyCandidatesBy7days: number;
  recentlyUpdatedCandidatesBy7days: number;
  todayUpdatedCandidates: number;
  invitedByMeCandidates: number;
  invitedPendingByMeCandidates: number;
  invitedAcceptedByMeCandidates: number;
  invitedRejectedByMeCandidates: number;
}


// Request DTO
export interface CandidateByItsStatusRequestDTO {
  candidateStatsByStatus: string;
}